const styles = {
  root: {
    pt: { xs: 2, md: 3 },
    pb: { xs: 2, md: 3 },
    display: 'grid',
    alignItems: 'center',
    backgroundColor: 'background.primary',
  },

  // rootBox: {
  //   paddingX: { xs: 2, lg: 'unset' },
  // },

  disclaimerReviews: {
    marginTop: 1,
    fontSize: '12px!important',
    lineHeight: '14px!important',
  },

  link: {
    textDecoration: 'none',
    color: (theme) => `${theme.palette.text.primary}!important`,
  },

  iconsContainer: {
    paddingLeft: 1,
    paddingRight: 1,
    '& svg': {
      width: 30,
      margin: '0 auto!important',
    },
    '& svg:first-of-type': {
      marginRight: 1,
    },
  },

  button: {
    padding: 1.5,
    fontSize: 12,
    margin: 0,
    backgroundColor: 'text.white',
    color: 'text.primaryDark',
    border: '1px solid rgba(0,0,0,0.2)',
    marginBottom: 0,
    '&:hover': {
      border: '1px solid rgba(0,0,0,0.2)',
    },
    '&.featured': {
      backgroundColor: '#8C46ED',
    },
    lineHeight: '18px !important',
  },

  paddingItem: {
    padding: { xs: 0, lg: 2 },
  },

  footerColumn: {
    display: 'flex',
    alignItems: 'center!important',
    flexDirection: 'row',
    marginTop: 2,
  },

  footerRow: (showBorders = true) => ({
    paddingX: showBorders ? { xs: 3, lg: 7 } : null,
    backgroundColor: showBorders ? 'background.tile' : null,
    border: showBorders ? '1px solid rgba(0, 0, 0, 0.12)' : null,
    borderTop: 'none',
    marginBottom: 3,
    borderRadius: showBorders ? '0 0 5px 5px' : null,
  }),

  iconsFooterContainer: (showBorders = true) => ({
    borderTop: { xs: '1px solid rgba(0, 0, 0, 0.12)', lg: 'unset' },
    borderLeft: showBorders ? { lg: '1px solid rgba(0, 0, 0, 0.12)' } : null,
    paddingY: { xs: 1, lg: 0 },
    '& .MuiGrid2-root': {
      paddingLeft: { lg: 1 },
      paddingRight: { lg: 1 },
    },
  }),

  visitUs: {
    alignItems: 'start',
    ':hover': {
      backgroundColor: 'none',
    },
    '& .Tile-icon': {
      '& svg': {
        width: 30,
        height: 30,
      },
    },
    '& .Tile-text': {
      textOverflow: 'initial',
      whiteSpace: 'initial',
      fontSize: 12,
      lineHeight: '14px',
      fontWeight: 'bold',
    },
  },

  addressIcon: {
    pl: { xs: 0, md: 1.5 },
  },
}

export default styles
